//@flow

import {useSelector} from 'react-redux';

import type {RootState} from '..';

const contactTypeSelector = (state: RootState) => state.information?.contact;

export function useContactTypes() {
  return useSelector(contactTypeSelector);
}
